class VideoSound {
    constructor(el) {
        console.log('videosound const')
        this.soundToggle = el;
        this.videoWrapper = el.closest('.video-wrapper');
        this.videoFrame = this.videoWrapper ? this.videoWrapper.querySelector('iframe') : null;
        this.isMuted = this.soundToggle.getAttribute('data-muted') === 'true';

        console.log(this.videoWrapper)
        console.log(this.videoFrame)
        if (this.soundToggle && this.videoFrame) {
            console.log('videosound init')
            this.init();
        }
    }

    init() {
        this.soundToggle.addEventListener('click', () => this.toggleSound());
    }

    toggleSound() {
        // Toggle muted state
        console.log('videosound toggle')
        this.isMuted = !this.isMuted;

        // Update UI
        this.soundToggle.setAttribute('data-muted', this.isMuted.toString());

        // Handle YouTube videos
        if (this.videoFrame.src.includes('youtube.com')) {
            this.toggleYouTubeSound();
        }
        // Handle Vimeo videos
        else if (this.videoFrame.src.includes('vimeo.com')) {
            this.toggleVimeoSound();
        }
    }

    toggleYouTubeSound() {
        // Update the URL parameter
        let newSrc = this.videoFrame.src;
        if (this.isMuted) {
            newSrc = newSrc.replace('mute=0', 'mute=1');
            if (!newSrc.includes('mute=')) {
                const separator = newSrc.includes('?') ? '&' : '?';
                newSrc = newSrc + separator + 'mute=1';
            }
        } else {
            newSrc = newSrc.replace('mute=1', 'mute=0');
        }

        // Only reload if URL changed
        if (newSrc !== this.videoFrame.src) {
            this.videoFrame.src = newSrc;
        }

        // Try YouTube postMessage API as well
        try {
            const message = JSON.stringify({
                event: 'command',
                func: this.isMuted ? 'mute' : 'unMute',
                args: []
            });
            this.videoFrame.contentWindow.postMessage(message, '*');
        } catch (e) {
            console.log('Could not send postMessage to YouTube iframe', e);
        }
    }

    toggleVimeoSound() {
        // Update the URL parameter for Vimeo
        let newSrc = this.videoFrame.src;
        if (this.isMuted) {
            newSrc = newSrc.replace('muted=0', 'muted=1');
            if (!newSrc.includes('muted=')) {
                const separator = newSrc.includes('?') ? '&' : '?';
                newSrc = newSrc + separator + 'muted=1';
            }
        } else {
            newSrc = newSrc.replace('muted=1', 'muted=0');
        }

        if (newSrc !== this.videoFrame.src) {
            this.videoFrame.src = newSrc;
        }

        // Try Vimeo postMessage API if available
        try {
            this.videoFrame.contentWindow.postMessage({
                method: this.isMuted ? 'setVolume' : 'setVolume',
                value: this.isMuted ? 0 : 1
            }, '*');
        } catch (e) {
            console.log('Could not send postMessage to Vimeo iframe', e);
        }
    }
}

export default VideoSound;
